import { useAnimate } from 'motion/react';
import { useEffect } from 'react';

interface Props {
  onComplete: () => void;
}

export const Div2 = ({ onComplete }: Props) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const enterAnimation = async () => {
      // initial state, instant
      await animate(scope.current, { opacity: 0 }, { duration: 0 });

      // actual animation
      await animate(scope.current, { opacity: 1 }, { duration: 1, ease: 'easeInOut' });
    };

    void enterAnimation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const exitAnimation = () => {
    void animate(scope.current, { opacity: 0 }, { duration: 1, ease: 'easeInOut' }).then(onComplete);
  };

  return (
    <div ref={scope} className="text-center text-xl md:text-2xl italic max-w-xl flex-col flex justify-center items-center gap-8">
      <span>Afin de réussir à ouvrir ce&nbsp;dossier secret, des&nbsp;indices vous aideront tout au long de votre&nbsp;mission.</span>
      <span>Suivez les&nbsp;instructions à chaque étape.</span>
      <span>Bon courage&nbsp;!</span>

      <button className="text-base button mt-8 bg-transparent not-italic" onClick={exitAnimation}>
        Suivant
      </button>
    </div>
  );
};
